import THREE from "realms-three";

export const BASE_EMISSIVE_COLOR = new THREE.Color(0x000000);
export const HIT_FLASH_COLOR = new THREE.Color(0xaa0000);
export const SELF_HIT_FLASH_COLOR = new THREE.Color(0xaa0000);
export const HIT_FLASH_DURATION_MS = 200;
